import {
  useAudioVideo,
  useMeetingManager,
} from 'amazon-chime-sdk-component-library-react';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useWebSocket } from '../components/WebSocketProvider/WebSocketProvider';

import { createMeeting, endMeeting, getMeetingToken } from '../api/meetingApi';
import { MeetingSessionConfiguration } from 'amazon-chime-sdk-js';
import { getMediaPermissions } from '../utils/getMediaPremission';

import { Modal } from 'antd';

import { ADMINS, MANAGERS } from '../helpers/constants';
const { confirm } = Modal;

const pingStream = (meetingInfo, sendData) => {
  const meeting = {
    streamId: meetingInfo._id,
    lastActivity: new Date(),
  };
  sendData({ meeting }, 'updateStream');
  console.log('ping Update Stream');
};

const useMeeting = ({ isFreeUser, user }) => {
  const meetingManager = useMeetingManager();
  const audioVideo = useAudioVideo();
  const [meetingInfo, setMeetingInfo] = useState(null);
  const { sendData } = useWebSocket();

  const [isOwner, setIsOwner] = useState(false);

  const startStream = async () => {
    const meeting = await createMeeting(user._id);
    await joinMeeting(meeting.meeting);
    setMeetingInfo(meeting.meeting);
    sendData({ meeting }, 'createStream');

    const created = new Date(meeting.createdAt);
    if (Date.now() - created < 1000 * 60) {
      setIsOwner(true);
    }

    setInterval(() => {
      pingStream(meeting, sendData);
    }, 60000 * 4);
  };

  const joinMeeting = async meeting => {
    try {
      if (!meeting) {
        throw new Error('Деталі зустрічі ще не завантажені.');
      }
      await getMediaPermissions();
      const currentMeetingId = meeting.MeetingId;
      const externalUserId = user._id;

      const ticket = await getMeetingToken(currentMeetingId, externalUserId);

      if (!ticket.AttendeeId || !ticket.JoinToken) {
        throw new Error('Некоректний токен учасника.');
      }

      if (!meeting.MeetingId || !meeting.MediaPlacement) {
        throw new Error('Некоректні деталі зустрічі.');
      }

      const meetingSessionConfiguration = new MeetingSessionConfiguration(
        meeting,
        ticket,
      );

      await meetingManager.join(meetingSessionConfiguration);

      await meetingManager.start();

      toast.success('Great. You have been joined the Dating Room');
    } catch (error) {
      toast.error('Error connection. Dating Room Session has been expired');
    }
  };

  useEffect(() => {
    if (!audioVideo) return;
    audioVideo.realtimeMuteLocalAudio();
  }, [audioVideo]);

  const onAdminDisconnect = meetingId => {
    if (!ADMINS.includes(user._id) && !MANAGERS.includes(user._id)) return;

    confirm({
      title: 'Disconnect Dating room and users OR Leave without changing',
      okText: 'Disconnect',
      cancelText: 'Leave',
      onOk() {
        endMeeting(meetingId);

        sendData({ users: [], meetingId: meetingId }, 'removeStream');
        toast.success('Meeting is closed!');
      },
    });
  };

  const disconnect = async () => {
    try {
      if (!meetingManager.meetingId) {
        return;
      }
      const meetingId = meetingManager.meetingId;
      onAdminDisconnect(meetingId);
      await meetingManager.leave();

      if (
        isFreeUser &&
        user._id === meetingInfo?.ExternalMeetingId &&
        isOwner
      ) {
        console.log('disconnect Meeting!');
        sendData(
          { users: [], meetingId: meetingInfo.MeetingId },
          'removeStream',
        );

        await endMeeting(meetingInfo.MeetingId);
        setIsOwner(false);

        toast.success('Meeting is closed!');
      }

      toast.success('You have been disconnected!');
    } catch (error) {
      console.error('Помилка при відключенні:', error);
      toast.error('Помилка відключення');
    }
  };

  const stopLogOutMeeting = async isFreeUser => {
    console.log('meeting info', meetingInfo);

    console.log({ ...meetingManager });

    try {
      if (!meetingManager.meetingId) {
        console.log('stop meeting 2');
        return;
      }

      if (isFreeUser) {
        console.log('disconnect Meeting!');
        await sendData(
          { users: [], meetingId: meetingManager.meetingId },
          'removeStream',
        );

        await endMeeting(meetingManager.meetingId);

        toast.success('Meeting is closed!');
      }

      toast.success('You have been disconnected!');
      await meetingManager.leave();
    } catch (error) {
      console.error('Помилка при відключенні:', error);
      toast.error('Помилка відключення');
    }
  };

  return { startStream, joinMeeting, disconnect, stopLogOutMeeting };
};

export default useMeeting;
